<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <h2>
          {{ $t('zerva.zerva_connect.title') }}
          <a href="https://blog.zwiz.app/zerva-connect-zwiz/" target="_blank" rel="noopener">
            <i style="font-size: 18px; color: #ed1e79;" class="ml-1 fas fa-question-circle"> </i>
          </a>
        </h2>
        <p>{{ $t('zerva.zerva_connect.desc') }}</p>
        <img src="/static/img/zerva/logo.png" width="150" />
      </v-flex>
      <v-flex style="text-align: right;" xs12 md6>
        <v-btn
          color="primary"
          @click="login()"
          v-if="!$store.state.zwizSsoToken && !selectedBot.connect_zerva_business_profile_id"
        >
          {{ $t('zerva.login_zwiz_member') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
      align-center
      ml-4
      v-if="$store.state.zwizSsoToken || selectedBot.connect_zerva_business_profile_id"
    >
      <v-flex xs12 md6>
        <template v-if="selectedBot.connect_zerva_business_profile_id">
          <span
            >{{ $t('zerva.shop_id') }}:
            {{ selectedBot.connect_zerva_shop_profile_setting_id }}</span
          >
          <br />
          <span
            >{{ $t('zerva.shop_name') }}:
            {{ selectedBot.connect_zerva_shop_profile_setting_name }}</span
          >
          <br />
          <a :href="zervaLink" target="_blank" style="text-decoration: underline;">{{
            $t('zerva.shop_link')
          }}</a>
        </template>
        <template v-else-if="businesses.length">
          <v-select
            v-model="businessId"
            v-validate="'required'"
            data-vv-name="businessId"
            :items="businesses"
            :placeholder="$t('select_business')"
            item-text="name"
            item-value="id"
            hide-details
            outline
          />
          <span class="red--text" v-show="errors.has('businessId')">{{
            $t('please_select_business')
          }}</span>
        </template>
        <span v-else>{{ $t('zerva.no_business_to_connect') }}</span>
      </v-flex>
      <v-flex style="text-align: right;" xs12 md6>
        <v-btn
          color="primary"
          outline
          @click="disconnect()"
          v-if="selectedBot.connect_zerva_business_profile_id"
        >
          {{ $t('zerva.disconnect_zwiz_member') }}
        </v-btn>
        <v-btn color="primary" @click="connect()" v-else-if="businesses.length">
          {{ $t('Connect') }}
        </v-btn>
        <v-btn color="primary" @click="logout()" v-else>
          {{ $t('logout') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <zerva-connect-follow-up v-if="selectedBot.connect_zerva_business_profile_id" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as ssoApi from '@/api/sso'
import ZervaConnectFollowUp from './ZervaConnectFollowUp'

export default {
  components: {
    ZervaConnectFollowUp
  },
  data() {
    return {
      businesses: [],
      businessId: '',
      zervaLink: ''
    }
  },
  async mounted() {
    const { token } = this.$route.query
    const { zwizSsoToken } = this.$store.state

    if (token) {
      this.$store.state.zwizSsoToken = token

      return this.$router.replace({ query: { plugin: 'zerva_connect' } })
    }

    if (zwizSsoToken) {
      try {
        this.$store.dispatch('loading')

        const { result } = await ssoApi.getChannelProfile({
          ssoToken: zwizSsoToken
        })

        this.businesses = result.channel_profile
          .filter(({ channel_profile_connect }) =>
            channel_profile_connect.find(({ id }) => id === 1)
          ) // 1 is Zerva
          .map(({ id, name }) => ({ id, name }))
      } catch (err) {
        this.$swal({
          type: 'error',
          title: this.$t('Error'),
          text: err.message
        })
      } finally {
        this.$store.dispatch('loading')
      }
    }

    this.zervaLink =
      process.env.NODE_ENV === 'production'
        ? `https://zerva.app/${this.selectedBot.connect_zerva_shop_profile_setting_id}`
        : `https://develop.zerva.app/${this.selectedBot.connect_zerva_shop_profile_setting_id}`
  },
  methods: {
    login() {
      const language = this.$i18n.locale()
      location.href =
        process.env.NODE_ENV === 'production'
          ? `https://zwiz.app/${language}/oauth?client_id=zwiz_cms&redirect_url=${location.href}`
          : `https://develop.zwiz.app/${language}/oauth?client_id=zwiz_cms&redirect_url=${location.href}`
    },
    logout() {
      this.zwizSsoToken = null
    },
    async connect() {
      let result = await this.$validator.validate()

      if (result) {
        try {
          await this.$store.dispatch('connectToZerva', {
            businessId: this.businessId
          })

          this.zervaLink =
            process.env.NODE_ENV === 'production'
              ? `https://zerva.app/${this.selectedBot.connect_zerva_shop_profile_setting_id}`
              : `https://develop.zerva.app/${this.selectedBot.connect_zerva_shop_profile_setting_id}`
        } catch (err) {
          this.$swal({
            type: 'error',
            title: this.$t('Error'),
            text: this.$t(err.message)
          })
        }
      }
    },
    async disconnect() {
      try {
        await this.$store.dispatch('disconnectZerva')
        this.zervaLink = null
      } catch (err) {
        this.$swal({
          type: 'error',
          title: this.$t('Error'),
          text: err.message
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ZervaConnect/index.vue